exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AddDistrict.css","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"importLoaders":1,"sourceMap":true,"modules":true,"localIdentName":"[name]-[local]-[hash:base64:5]","minimize":false,"discardComments":{"removeAll":true}}!../~/postcss-loader?pack=default!./routes/admin/districts/add_district/AddDistrict.css
// module id = 1330
// module chunks = 0